<template>
  <div :class="success ?  'GoogleSearch' : 'GoogleSearch__error' ">
    <div class="GoogleSearch__header">
      <span>Google Search Results</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && success">
      <div v-if="isValidJson" class="GoogleSearch__body">
        <div class="GoogleSearchOutput__container">
          <div class="GoogleSearchOutput__list" v-for="result in outputObject.results" :key="result.id">
            <img :src="getFaviconUrl(result.link)" style="margin-top: 3px"/>
            <div>
              <span><a :href="result.link" target="_blank" rel="noopener noreferrer">{{ result.title }}</a></span><br>
              <span>{{ result.snippet }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="DefaultAction__body">
        {{ outputObject }}
      </div>
    </div>

    <div v-if="extend && !success">
      <div class="GoogleSearch__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';

export default {
  name: 'google-search-output',
  components: {},
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output);
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {
    getFaviconUrl(url, size = 20) {
      try {
        const domain = new URL(url).hostname;
        return `https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`;
      } catch (error) {
        console.error('Invalid URL:', error);
        return null;
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import './index';
</style>
